import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ImpersonateUser.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImpersonateUserModal from './ImpersonateUserModal';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { AdminContext } from '../../contexts/AdminContext';
import logComponent from '../../common/logComponent';

export default function ImpersonateUser() {
  const environmentContext = useContext(EnvironmentContext);
  const adminContext = useContext(AdminContext);
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [impersonating, setImpersonating] = useState(environmentContext.selectedImpersonationUserEmail != null);
  const firstTabRef = useRef(null);
  const lastTabRef = useRef(null);
  const openBtnRef = useRef(null);
   
  const setOpenBtnRef = el => openBtnRef.current = el;

  if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser rendered'); }

  useEffect(() => {
    if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser useEffect [environmentContext, visible]'); }
    if ((environmentContext && environmentContext.user && (!environmentContext.user.canImpersonate && !environmentContext.user.hasImpersonateViaGroupsOrOverride)) && visible == true) {
      beginImpersonateUserExit();
    }
  }, [environmentContext?.user?.hasImpersonateViaGroupsOrOverride, environmentContext?.user?.canImpersonate, visible]);

  const beginImpersonateUserExit = () => {
    if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser beginImpersonateUserExit'); }
    setImpersonating(false);
    setVisible(false);



  }


  const toggleImpersonation = (e) => {
    if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser toggleImpersonation'); }



    if (impersonating) {
      setImpersonating(false);
      setVisible(false);
      environmentContext.clearSelectedImpersonationUser();
      adminContext.setShouldUpdateGroups(true);
      navigate('/');

    } else {
      setVisible(true);
    }
  }

  const hideModal = (e) => {
    if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser hideModal'); }
    const { selectedImpersonationUserEmail } = environmentContext;

    setImpersonating(selectedImpersonationUserEmail);
    setVisible(false);
    navigate('/');
  }


  const handleKeyDown = (e) => {
    if (logComponent('ImpersonateUser')) { console.debug('ImpersonateUser handleKeyDown'); }
    //TODO:  What to put here.  Method was missing
  }

  return (
    <div className="Impersonate-User">
      <button
        ref={setOpenBtnRef}
        className="Impersonate-User__open-btn"
        onClick={toggleImpersonation}
        onKeyDown={handleKeyDown}>
        <FontAwesomeIcon className={`Impersonate-User__toggle-icon-${impersonating ? 'active' : 'inactive'}`} icon="eye"></FontAwesomeIcon>
      </button>

      {visible &&
        <ImpersonateUserModal
          hide={hideModal}
        />

      }

    </div>
  );
}
